module.exports = __webpack_public_path__ + "img/share.a0c88e9d.png";